import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import FileInput from '../../Fields/FileInput/FileInput';
import DropzoneArea from '../../Fields/FileInput/DropzoneArea';
import ImageList from '../../Fields/FileInput/ImageList';

const AdNewFormImage = (props) => {
  const { photosAttributes, removePhoto, existingPhotos, } = props;
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.photoInputWrapper}>
        <FileInput
          name="photos_attributes"
          classNameLabel="file-input-label"
          className="file-input"
          currentPhotos={photosAttributes}
          dropzone_options={{
            multiple: true,
            accept: 'image/jpg, image/jpeg, image/png, image/bmp',
          }}
        >
          <DropzoneArea />
        </FileInput>
        <ImageList
          currentPhotos={photosAttributes}
          removePhoto={removePhoto}
          existingPhotos={existingPhotos}
        />
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photoInputWrapper: {
    width: 'clamp(400px, 58%, 100vh)',
    margin: '1em',
  },
});

AdNewFormImage.propTypes = {
  existingPhotos: PropTypes.arrayOf(PropTypes.object).isRequired,
  removePhoto: PropTypes.func.isRequired,
  photosAttributes: PropTypes.arrayOf(PropTypes.object),
};

AdNewFormImage.defaultProps = {
  photosAttributes: [],
};


export default AdNewFormImage;
